import { getUrlConfig } from "./urlConfig";

/**
 * ドメインのタイプ
 */
export enum DOMAIN {
  /* www.so-net.ne.jp */
  SONET,
  /* support.so-net.ne.jp */
  SUPPORT,
  /* www.sonynetwork.co.jp */
  SONY_NETWORK,
  /* */
  CS_MYPAGE,
}

const HTTPS_SCHEME = "https://";
const HTTP_SCHEME = "http://";

/**
 * 環境ごとに切り替わるURLを生成する
 * 例）url = SONET の場合
 * ローカル環境：https://ssoip.so-net.ne.jp
 * テスト環境：https://ssoip.so-net.ne.jp
 * 本番環境：https://www.so-net.ne.jp
 * @param domain 切り替えるドメイン
 * @param path https://www.so-net.ne.jp 以下の相対パス
 * @param httpScheme Schemeをhttpに切り替える
 */
const createUrl = (domain: DOMAIN, path: string, httpScheme?: boolean) => {
  const scheme = httpScheme ? HTTP_SCHEME : HTTPS_SCHEME;
  const urlConfig = getUrlConfig();
  switch (domain) {
    case DOMAIN.SONET:
      return scheme + urlConfig.SONET + path;
    case DOMAIN.SUPPORT:
      return scheme + urlConfig.SONET_SUPPORT + path;
    case DOMAIN.SONY_NETWORK:
      return scheme + urlConfig.SONET_NETWORK + path;
    case DOMAIN.CS_MYPAGE:
      return scheme + urlConfig.SONET_CS + path;
    default:
      // TODO ハンドリングは別ストーリーで検討
      throw new Error(`Invalid domain: domain=${domain}, path=${path}`);
  }
};
export default createUrl;

export const createExternalUrl = (url: string, urlPrefix?: string) => {
    const isExternalLink = /https?:\/\//g.test(url);
    if (isExternalLink) {
        return url;
    }

    const path = `${urlPrefix ?? '/mypage/myp'}${url.substring(1)}`;
    return createUrl(DOMAIN.SONET, path);
};

export type GetParams = [string, string][];

/**
 * urlにGETパラメーターを付与する
 * @param url
 * @param params
 */
export const addQueryParams = (url: string, params: GetParams) => {
    if (params.length === 0) {
        return url;
    }
    const connectCharacter = url.includes('?') ? '&' : '?';
    return encodeURI(
        url +
            params
                .map((p, index) => {
                    if (index === 0) {
                        return `${connectCharacter}${p[0]}=${p[1]}`;
                    }
                    return `&${p[0]}=${p[1]}`;
                })
                .reduce((p, c) => p + c)
    );
};
